import { Tooltip } from '@sgme/ui';
import { FormattedMessage } from 'react-intl';

import { FixingOrderRow } from '@/App/BulkOrder/BulkOrderTables/FixingOrderRow.tsx';

type OrderTableProps = {
  orderIds: string[] | undefined;
  bdrId?: string;
  currencyPair?: string;
  isImportingWithNoFixingRight?: boolean;
  tabId: string;
};

export const FixingOrderTable = (props: OrderTableProps) => {
  const { orderIds, bdrId, currencyPair, tabId, isImportingWithNoFixingRight = false } = props;

  if (isImportingWithNoFixingRight) {
    return (
      <>
        <h3 className="d-flex align-items-center gap-3 mb-2 mt-5">
          <FormattedMessage id="fixing.table.title" />
        </h3>
        <div className="alert alert-discreet-warning text-start mt-1" role="alert">
          <i className="icon icon-md icon-outlined me-2">warning</i>
          <FormattedMessage id="import.warning.message" values={{ orderType: 'fixing' }} />
        </div>
      </>
    );
  }

  return orderIds && orderIds.length > 0 ? (
    <>
      <h3 className="d-flex align-items-center gap-3 mb-2 mt-5">
        <FormattedMessage id="fixing.table.title" />
        <div className="badge badge-outline-primary rounded-pill">{orderIds.length}</div>
      </h3>
      <table
        className="table table-sm table-bordered table-thead-bordered table-body-bordered table-striped table-hover bg-lvl1"
        data-e2e={
          bdrId === undefined || currencyPair === undefined
            ? 'fixing-order-table'
            : `fixing-order-table-${bdrId}-${currencyPair.replaceAll('/', '-')}`
        }
      >
        <thead>
          <tr className="align-middle">
            <th>
              <FormattedMessage id="table.header.status" />
            </th>

            <th>
              <FormattedMessage id="table.header.orderId" />
            </th>

            <th>
              <FormattedMessage id="table.header.bdr" />
              <Tooltip contents={'Account ID'}>
                <i className="icon icon-sm ps-2">info</i>
              </Tooltip>
            </th>

            <th>
              <FormattedMessage id="table.header.currencyPair" />
            </th>

            <th>
              <FormattedMessage id="table.header.way" />
            </th>

            <th>
              <FormattedMessage id="table.header.notional" />
            </th>

            <th>
              <FormattedMessage id="table.header.fixingReference" />
            </th>

            <th>
              <FormattedMessage id="table.header.priceType" />
            </th>

            <th>
              <FormattedMessage id="table.header.fixingDate" />
            </th>

            <th>
              <FormattedMessage id="table.header.deliveryDate" />
            </th>

            <th>
              <FormattedMessage id="table.header.fixingPlace" />
            </th>

            <th>
              <FormattedMessage id="table.header.fixingTime" />
            </th>

            <th>
              <FormattedMessage id="table.header.marginType" />
            </th>

            <th>
              <FormattedMessage id="table.header.commercialMargin" />
            </th>
          </tr>
        </thead>

        <tbody className="bg-lvl1">
          {orderIds.map((bulkOrderId) => (
            <FixingOrderRow key={bulkOrderId} orderId={bulkOrderId} tabId={tabId} />
          ))}
        </tbody>
      </table>
    </>
  ) : null;
};
